import { motion } from 'framer-motion';

export const MentionsLegales = () => {
  return (
    <div data-testid="mentions-legales-page" className="min-h-screen pt-20 bg-[#0a0908]">
      <div className="max-w-4xl mx-auto px-6 sm:px-12 py-24">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="font-heading text-4xl sm:text-5xl font-light text-[#fdfbf7] mb-12">
            Mentions légales
          </h1>
          
          <div className="space-y-8 text-[#a39c93] font-body leading-relaxed">
            <section>
              <h2 className="font-heading text-2xl text-[#fdfbf7] mb-4">Éditeur du site</h2>
              <p>
                Rozier Menuiserie<br />
                [Adresse à compléter]<br />
                Téléphone : 06 00 00 00 00<br />
                Email : contact@rozier-menuiserie.fr
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl text-[#fdfbf7] mb-4">Hébergement</h2>
              <p>
                [Informations hébergeur à compléter]
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl text-[#fdfbf7] mb-4">Propriété intellectuelle</h2>
              <p>
                L'ensemble du contenu de ce site (textes, images, logos, vidéos) est la propriété 
                exclusive de Rozier Menuiserie, sauf mention contraire. Toute reproduction, 
                représentation, modification, publication ou adaptation de tout ou partie des 
                éléments du site est interdite sans autorisation écrite préalable.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl text-[#fdfbf7] mb-4">Crédits</h2>
              <p>
                Conception et réalisation : <a href="https://axeris-labs.fr" target="_blank" rel="noopener noreferrer" className="text-[#C5A059] hover:text-[#d6b46e] transition-colors">Axeris Labs</a>
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl text-[#fdfbf7] mb-4">Responsabilité</h2>
              <p>
                Les informations fournies sur ce site le sont à titre indicatif. 
                Rozier Menuiserie ne saurait garantir l'exactitude, la complétude ou 
                l'actualité des informations diffusées sur le site.
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};
